<ion-header translucent>
	<ion-toolbar>
		<ion-title>{{ 'invoiceEmail.title' | translate }}</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	@if (state === 'form') {
		<ion-item class="input-field outlined">
			<ion-label position="floating">{{ 'invoiceEmail.emailLabel' | translate }}</ion-label>
			<ion-input [(ngModel)]="email" placeholder="info@smoothr.de" type="email"></ion-input>
		</ion-item>

		<ion-button (click)="send()" [disabled]="!email" class="ion-margin-top" expand="block"> {{ 'common.send' | translate }}</ion-button>
	}
	@if (state === 'success') {
		<div class="success-container ion-text-center">
			<img [alt]="'common.altSuccess' | translate" class="success-icon" src="/assets/icon/success.svg" />
			<h2>{{ 'invoiceEmail.sent' | translate }}</h2>
			<ion-button (click)="done()" class="ion-margin-top" expand="block"> {{ 'common.done' | translate }}</ion-button>
		</div>
	}
</ion-content>
